import React, { createContext, useContext, useRef, useEffect, useCallback } from 'react';

const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];

const InteractionContext = createContext(null);

export function InteractionProvider({ children }) {
  const lastInteractionAt = useRef(Date.now());

  useEffect(() => {
    const update = () => { lastInteractionAt.current = Date.now(); };
    EVENTS.forEach(e => window.addEventListener(e, update, { passive: true }));
    return () => EVENTS.forEach(e => window.removeEventListener(e, update));
  }, []);

  const getLastInteractionAt = useCallback(() => lastInteractionAt.current, []);

  return (
    <InteractionContext.Provider value={{ getLastInteractionAt }}>
      {children}
    </InteractionContext.Provider>
  );
}

export function useInteraction() {
  return useContext(InteractionContext);
}
